import { Styles } from '@monkvision/types';

export const styles: Styles = {
  container: {
    height: '100%',
    width: '100%',
  },
};
